import React from 'react'
import ReactDOM from 'react-dom/client'

import './i18n'
import './index.css'
import App from './App.jsx'

// Installable, and only that: registration is what makes the browser offer "add to home screen".
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // An admin portal that cannot be installed still works; there is nothing to say about it.
    })
  })
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
